import { DatePicker, TimePicker } from '@monash/portal-react';
import { Controller } from 'react-hook-form';
import c from './date-and-time.module.scss';
import InlineErrorMessage from '../inline-error-message/InlineErrorMessage';
import classNames from 'classnames';

const DateAndTime = ({
  className,
  required = false,
  errorMessage,
  label,
  names,
  onBlur,
  validateDate,
  validateTime,
  disabled,
  renderVertically = false,
  control,
}) => {
  const wrapperClass = classNames(c.inputGroup, className);

  return (
    <div className={wrapperClass}>
      <label>{label}</label>

      <div
        className={classNames(c.dateAndTime, {
          [c.vertical]: renderVertically,
          [c.horizontal]: !renderVertically,
        })}
      >
        <Controller
          control={control}
          name={names.date}
          rules={{
            validate: validateDate,
          }}
          render={({
            field: { onBlur: controllerOnBlur, onChange, value },
          }) => (
            <DatePicker
              dateFormat="dd/MM/yyyy"
              disablePast={true}
              selectedDay={value}
              onChange={onChange}
              onBlur={(event) => {
                controllerOnBlur(event);
                onBlur?.({ event, name: names.date });
              }}
              disabled={disabled}
            />
          )}
        />

        <Controller
          control={control}
          name={names.time}
          rules={{
            validate: validateTime,
            required,
          }}
          render={({
            field: { onBlur: controllerOnBlur, onChange, value },
          }) => (
            <TimePicker
              time={value}
              onChange={onChange}
              onBlur={(event) => {
                controllerOnBlur(event);
                onBlur?.({ event, name: names.time });
              }}
              disabled={disabled}
            />
          )}
        />
      </div>
      {errorMessage && <InlineErrorMessage message={errorMessage} />}
    </div>
  );
};

export default DateAndTime;
